// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';
import {eshopUserToolsRefresh} from '../webActions/eshopUserToolsRefresh';
import tippy from 'tippy.js';

export default class EshopUserToolsHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  didMount() {
    this.submitElement = this.element.querySelector('[type="submit"]');
    this.submitElement.addEventListener('click', this.handleSubmit);
  }
  willUnMount() {
    this.submitElement.removeEventListener('click', this.handleSubmit);
  }

  createFormData( element) {
    // pokud jsem v detailu produktu, widget je samostatny `form`, FormData se vezmou z widgetu
    if ( element instanceof HTMLFormElement ) return new FormData(element);

    // pokud jsme v kosiku, widget je uvnitr formu (kosik), FormData musim sestavit
    const inputs = element.querySelectorAll('input');
    const formData = new FormData();
    for (let i = 0; i < inputs.length; ++i) {
      formData.append(inputs[i].name, inputs[i].value);
    }
    return formData;
  };

  handleSubmit(event) {
    const {
      activeClass,
      tooltip,
      jsonUrl,
    } = this.props;

    event.preventDefault();

    const buttonLabel = this.submitElement.querySelector('.button-label');

    const xhr = new XMLHttpRequest();
    const formData = this.createFormData(this.element);
    const requestUrl = this.element.getAttribute('action') || this.element.getAttribute('data-action');
    formData.append(this.submitElement.name, this.submitElement.value);

    CursorSpinner.pushToQueue('eshopUserToolsHandle');

     xhr.onload = () => {
      if (xhr.status == 200) {
        eshopUserToolsRefresh();

        const xhrJson = new XMLHttpRequest();
        xhrJson.onreadystatechange = () => {
          if (xhrJson.readyState == 4 && xhrJson.status == 200) {
            try {
              const json = JSON.parse(xhrJson.responseText);
              if ((tooltip) || (!tooltip && !json.resultState)) {
                this.renderTooltip(json.result, json.resultState);
              }

              if (json.resultState) {
                if (this.submitElement.classList.contains(activeClass)) {
                  this.submitElement.name = this.submitElement.name.replace('removeItemFromList','addItemToList');
                  buttonLabel.innerHTML = this.submitElement.getAttribute('data-default-title');

                } else {
                  this.submitElement.name = this.submitElement.name.replace('addItemToList','removeItemFromList');
                  buttonLabel.innerHTML = this.submitElement.getAttribute('data-active-title');
                }

                this.submitElement.classList.toggle(activeClass);
              }

            } catch (error) {
              throw Error;
            }
          }
        }
        const lang = document.querySelector('html').getAttribute('lang');
        xhrJson.open('post','/qf/' + lang + '/ramjet/include@' + jsonUrl, true);
        xhrJson.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhrJson.send();
      }
      CursorSpinner.removeFromQueue('eshopUserToolsHandle');
    };

    xhr.open('post',requestUrl, true);
    xhr.send(formData);
  }

  renderTooltip(result, resultState) {
    const theme = resultState ? 'esp' : 'esp-error';

    this.tip = tippy(this.submitElement, {
      arrow: true,
      theme: theme,
      placement: 'top',
      trigger: 'manual',
      allowHTML: true,
      interactive: true,
    });
    this.tip.setContent(result);
    this.tip.show();
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopUserToolsHandler.js